import ItemType from "../Models/ItemType";
import Firebase from "firebase";

const toggleFavorite = (id: string, type: ItemType, favorites: any, userID: string) => {

    let localFavorites = favorites[type] ?? {};

    if (localFavorites[id])
        delete localFavorites[id];
    else
        localFavorites[id] = true;

    let value = Object.keys(localFavorites).length > 0
        ? localFavorites
        : null

    Firebase
        .firestore()
        .collection('users')
        .doc(userID)
        .collection('Favorites')
        .doc(type)
        .set({value})
        .catch((error) => {
            // console.log(error);
        });
};

export default toggleFavorite;